module.exports = __webpack_public_path__ + "static/img/45.0123f2a9.png";